import styled from '@emotion/styled'

import { MOBILE } from '../guided-toolbox/utils/breakpoints'
import { cardBorderColor } from './advice/shared'

/** Displays two page actions in a pill-shaped desktop container and an equal-width mobile row. */
const FooterBar = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 13px 18px;
  border: 2px solid ${cardBorderColor};
  border-radius: 999px;

  ${MOBILE} {
    border: none;
    border-radius: 0;

    /* Stretch both actions to the height of the longer wrapped label. */
    align-items: stretch;

    /* Include buttons nested inside display: contents wrappers. */
    & button {
      flex: 1 1 0;
      padding: 0 16px;
    }
  }
`

export default FooterBar
